/**
 * Cookie Consent Feature Flags
 * 
 * Control visibility of new Cookie Modal buttons.
 * All flags default to FALSE to maintain backward compatibility with existing UI.
 * 
 * When all flags are FALSE, the UI behaves identically to before the update.
 */

export const COOKIE_FEATURES = {
  /**
   * Show "Learn More" button in Cookie Modal
   * - true:  Display "Learn More" button
   * - false: Hide "Learn More" button
   */
  SHOW_LEARN_MORE: false,

  /**
   * Show "Accept All" button in Cookie Modal
   * - true:  Display "Accept All" button
   * - false: Hide "Accept All" button (existing "Accept" button behavior preserved)
   */
  SHOW_ACCEPT_ALL: true,

  /**
   * Show "Necessary Only" button in Cookie Modal
   * - true:  Display "Accept Necessary Only" button
   * - false: Hide this button
   */
  SHOW_NECESSARY_ONLY: true,

  /**
   * Show "Cookie Settings" button/panel in Cookie Modal
   * - true:  Display settings toggle and detailed preferences
   * - false: Hide settings panel
   */
  SHOW_SETTINGS: true
};

export default COOKIE_FEATURES;